export enum DialogMode {
  CREATE = 'create',
  EDIT = 'edit'
} 